import React, { ReactNode } from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import "./recordLine.scss";

interface RecordLineProps {
  name: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
  children?: ReactNode | ReactNode[];
}

const RecordLine: React.FC<RecordLineProps> = ({
  children,
  isSelected,
  name,
  description,
  onClick,
}) => {
  return (
    <div className="row-style" onClick={onClick}>
      <Row
        className={isSelected ? "selected-color" : "unselected-color"}
        spacing={"300"}
        widths={["fill", "fit"]}
        spacingInset={"200 400"}
        overflowX="hidden"
      >
        <Column spacing={"100"} spacingInset={"200"} width={"100%"}>
          <Text type={isSelected ? "h50" : "b200"}>{name}</Text>
          <Text type="b200" color="secondary" className="row-style__description" truncate>
            {description}
          </Text>
        </Column>
        {children}
      </Row>
    </div>
  );
};

export default RecordLine;
